import React, { useState } from "react";
import ForgetPWD from "./ForgetPWD";
import Login from "./Login";
import Otp from "./Otp";
import { lang } from "../../lang";
import { useEffect } from "react";
 
const LoginPage = () => {
  const [ln,setLn] = useState('en')
  const [otp, setOtp] = useState(false);
  const [forgetPwd, setForgetPwd] = useState(false);
  const [activeSection, setActiveSection] = useState(1);
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
  return (
    <>
      <div className="flex-center">
        <div className="login-container">
          <h1 className="login-title">{lang && Object.keys(lang).length > 0 ? lang[ln]?.PrivacyPolicies["Welcome to Recruiter"]:""} </h1>
          <div className="d-flex space-between mt-2 submenu-bar">
            <p
              className={activeSection === 1 || activeSection === 2 ? "login-active" : "login"}
              onClick={() => {
                setActiveSection(1)
              }}
            >
              {lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword["Login"]:""}
            </p>
            <p
              className={activeSection === 3 || activeSection === 4 ? "login-active" : "login"}
              onClick={() => {
                setActiveSection(3)
              }}
            >
              {lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword["OTP"]:""}
              
            </p>
          </div>
          <hr className="line" style={{ marginTop: "-4px" }} />

          {activeSection === 1 || activeSection === 2 ? (
            activeSection === 1 ? <Login setActiveSection={setActiveSection} /> : <ForgetPWD setActiveSection={setActiveSection}/>
          ) : (
           <Otp/>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginPage;
